// extracted by mini-css-extract-plugin
export default {"fitContent":"style_fitContent__iyeGE"};